import { Address, TripConnection, MeetingPoint, LCGAddressDetails } from '../redux/reducers/api-types';

export default class AddressUtils {
    static extractLoc = (obj: LCGAddressDetails) => {
        if (!obj) {
            return null;
        }
        const { location, address } = obj;

        const splitString = address.postal_code ? `, ${address.postal_code} ${address.city}` : `, ${address.city}`;
        const street = address.number ? `${address.number} ${address.street}` : address.street;

        const res = {
            lat: location[0],
            lng: location[1],
            address: {
                name: address.text.split(splitString)[0],
                country: address.country,
                city: address.city,
                postal_code: address.postal_code,
                street: street,
            },
        };

        return res;

        // city: "Paris"
        // country: "France"
        // country_code: "FR"
        // level: null
        // number: null
        // postal_code: "75015"
        // state: "Île-de-France"
        // state_code: "IDF"
        // street: "Place Raoul Dautry"
        // text: "SNCF-Paris Montparnasse, Place Raoul Dautry, 75015 Paris, France"

        // text: "Paris, Île-de-France"
        // vicinity: "Île-de-France"
        // __proto__: Object
        // categories: ["LOCALITY_CITY"]
        // distance: 557
        // location: (2) [48.85718, 2.34141]
        // name: "Paris"

        // start_location[address][name]: 77 Rue Jean Jaurès
        // start_location[address][country]: France
        // start_location[address][city]: Puteaux
        // start_location[address][postal_code]: 92800
    };

    static favoritesToAddress(objAddress: Partial<Address>, separator: string = ', '): string {
        let res: string = null;
        if (objAddress) {
            const infos = [
                objAddress.name || objAddress.street,
                `${objAddress.postal_code ?? ''} ${objAddress.city ?? ''}`?.trim(),
                objAddress.country,
            ];
            res = infos.filter((el) => el).join(separator);
        }

        return res;
    }

    static objectToAddress(objAddress: Partial<Address>, separator: string = ', '): string {
        let res: string = null;
        if (objAddress) {
            const infos = [objAddress.street, objAddress.postal_code, objAddress.city, objAddress.country];
            res = infos.filter((el) => el).join(separator);
        }

        return res;
    }

    static meetingPointToString(meetingPoint: MeetingPoint, nameboard: boolean = false): string {
        if (!meetingPoint) {
            return '';
        } else {
            const {
                name,
                poi: { menuname },
                rdv,
                rdv_with_nameboard,
                rdv_without_nameboard,
            } = meetingPoint;

            let text = rdv?.fr;
            if (nameboard && rdv_with_nameboard) {
                text = rdv_with_nameboard.fr;
            } else if (!nameboard && rdv_without_nameboard) {
                text = rdv_without_nameboard.fr;
            }

            return `${menuname.fr} ${name.fr} : ${text}`;
        }
    }

    static tripConnectionToString(tripConnection: TripConnection, hasMeetingPoint: boolean = false): string {
        if (!tripConnection) {
            return '';
        }
        const { carrier_IATA_code, flight_number, arrival_terminal, train_number } = tripConnection;
        if (carrier_IATA_code) {
            return `, Vol ${carrier_IATA_code}${flight_number}${hasMeetingPoint ? ` (Terminal d'arrivée: ${arrival_terminal})` : ''}`;
        }
        return `, Train N°${train_number}`;
    }

    static tripConnectionGetNumber(tripConnection: TripConnection): any {
        if (!tripConnection || (!tripConnection.train_number && !tripConnection.flight_number)) {
            return {};
        } else {
            const { carrier_IATA_code, flight_number, train_number } = tripConnection;
            return carrier_IATA_code ? { flight_number: `${carrier_IATA_code}${flight_number}` } : { train_number };
        }
    }

    static isSameLocation(location1: any, location2: any): boolean {
        if (!location1 || !location2) {
            return false;
        }
        const loc1 = location1.position || location1.location?.position || location1.location;
        const loc2 = location2.position || location2.location?.position || location2.location;

        if (!loc1 || !loc2) {
            return false;
        }

        const lat1 = loc1[0] || loc1.lat;
        const lng1 = loc1[1] || loc1.lng;
        const lat2 = loc2[0] || loc2.lat;
        const lng2 = loc2[1] || loc2.lng;

        return lat1 === lat2 && lng1 === lng2;
    }
}
